import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import AppLayout from '../components/AppLayout.vue'

const routes = [
  {
    path: '/',
    redirect: '/employees',
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { guest: true }
  },
  {
    path: '/employees',
    name: 'EmployeeList',
    component: () => import('../views/employees/EmployeeList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/employees/new',
    name: 'EmployeeCreate',
    component: () => import('../views/employees/EmployeeForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/employees/:id',
    name: 'EmployeeDetail',
    component: () => import('../views/employees/EmployeeDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/employees/:id/edit',
    name: 'EmployeeEdit',
    component: () => import('../views/employees/EmployeeForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/services',
    name: 'ServiceList',
    component: () => import('../views/services/ServiceList.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/services/new',
    name: 'ServiceCreate',
    component: () => import('../views/services/ServiceForm.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/services/:id/edit',
    name: 'ServiceEdit',
    component: () => import('../views/services/ServiceForm.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.auth.token !== null
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isGuestRoute = to.matched.some(record => record.meta.guest)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)

  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (isGuestRoute && isAuthenticated) {
    next('/')
  } else if (requiresAdmin && store.state.auth.user?.role !== 'ADMIN') {
    next('/')
  } else {
    next()
  }
})

export default router
